import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const CompanyInfo = ({ 
interview
 }) => {


return (
<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
<div className="flex items-center justify-between mb-4">
<h2 className="text-xl font-bold text-gray-900">Company Information</h2>
{interview.companyInfo.website && (
<a
href={interview.companyInfo.website}
target="_blank"
rel="noopener noreferrer"
className="text-blue-600 hover:text-blue-700 text-sm flex items-center gap-1"
>
Visit Website
<ExternalLink className="w-4 h-4" />
</a>
)}
</div>

<div className="space-y-6">
<div>
<p className="text-gray-700">{interview.companyInfo.description}</p>
</div>

<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
<div className="bg-gray-50 rounded-lg p-4">
<p className="text-sm text-gray-600 mb-1">Industry</p>
<p className="font-semibold text-gray-900">{interview.companyInfo.industry}</p>
</div>
<div className="bg-gray-50 rounded-lg p-4">
<p className="text-sm text-gray-600 mb-1">Employees</p>
<p className="font-semibold text-gray-900">{interview.companyInfo.employeeCount}</p>
</div>
<div className="bg-gray-50 rounded-lg p-4">
<p className="text-sm text-gray-600 mb-1">Founded</p>
<p className="font-semibold text-gray-900">{interview.companyInfo.founded}</p>
</div>
<div className="bg-gray-50 rounded-lg p-4">
<p className="text-sm text-gray-600 mb-1">Headquarters</p>
<p className="font-semibold text-gray-900">{interview.companyInfo.headquarters}</p>
</div>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-2">Recent News & Updates</h3>
<ul className="space-y-2">
{interview.companyInfo.recentNews.map((news, index) => (
<li key={index} className="flex items-start gap-2">
<TrendingUp className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
<span className="text-gray-700">{news}</span>
</li>
))}
</ul>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-2">Last Recruitment Campaign</h3>
<p className="text-gray-700">{interview.companyInfo.lastRecruitmentCampaign}</p>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-2">Company Culture</h3>
<div className="grid grid-cols-1 md:grid-cols-2 gap-2">
{interview.companyInfo.culture.map((item, index) => (
<div key={index} className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0" />
<span className="text-gray-700">{item}</span>
</div>
))}
</div>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-2">Tech Stack</h3>
<div className="flex flex-wrap gap-2">
{interview.companyInfo.techStack.map((tech, index) => (
<span key={index} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
{tech}
</span>
))}
</div>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-2">Benefits</h3>
<div className="grid grid-cols-1 md:grid-cols-2 gap-2">
{interview.companyInfo.benefits.map((benefit, index) => (
<div key={index} className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
<span className="text-gray-700">{benefit}</span>
</div>
))}
</div>
</div>
</div>
</div>
);
};

export default CompanyInfo;